/**
 * Удаляет локальные кеши прогресса (уроки, лексика, шаги), чтобы при смене аккаунта
 * не подтягивались данные предыдущего пользователя из localStorage/sessionStorage.
 * Не трогает token / adminToken.
 */
import { invalidateCacheByPrefix } from './requestCache';

const LOCAL_STORAGE_KEEP = new Set(['token', 'adminToken']);

function clearSessionStorageCaches(): void {
  if (typeof window === 'undefined' || !('sessionStorage' in window)) return;
  try {
    const ss = window.sessionStorage;
    const keys = Object.keys(ss);
    for (const key of keys) {
      if (
        key === 'vocab_topics_progress' ||
        key === 'vocab_daily_word_stats' ||
        key === 'activity_streak' ||
        key === 'vocab_access' ||
        key === 'lessons_list' ||
        key.startsWith('kunlik:') ||
        key.startsWith('falarus:') ||
        key.startsWith('falarus_google_') ||
        key.startsWith('vocab_subtopics_') ||
        key.startsWith('vocab_word_groups_') ||
        key.startsWith('vocab_tasks_') ||
        key.startsWith('vocab_steps_')
      ) {
        ss.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }
}

function clearLocalStorageProgress(): void {
  if (typeof window === 'undefined' || !('localStorage' in window)) return;
  try {
    const keys = Object.keys(window.localStorage);
    for (const key of keys) {
      if (LOCAL_STORAGE_KEEP.has(key)) continue;
      if (
        key === 'lessonTaskResults' ||
        key === 'falarus.wordSwipe.stars' ||
        key === 'falarus.verbGame.best' ||
        key === 'falarus:dailyVocabProgress:v1' ||
        key === 'falarus:ai-consent:v1' ||
        key.startsWith('vocab-') ||
        key.startsWith('vocab_stats_')
      ) {
        window.localStorage.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }
}

export function clearUserProgressCaches(): void {
  clearLocalStorageProgress();
  clearSessionStorageCaches();
  invalidateCacheByPrefix('');
  // vocabularyStepsStore.setState({}) was called here for the legacy
  // standalone vocabulary flow. That flow and the store were removed
  // when the product collapsed to the 182-day kunlik plan, so this
  // reset is now a no-op.
}
